import { all } from 'redux-saga/effects'

import { loaderSaga } from './loader/saga'
import { syncSaga } from './sync/saga'

export function* userSaga() {
  yield all([loaderSaga(), syncSaga()])
}
